import { closeLocationSelector, openLocationSelector } from '../utils/location';
import { LocationSelector } from '../types/location';
import { useMediaQuery, useTheme } from '@mui/material';

export const useLocationSelector = (): {
  close: () => void;
  open: (locationSelector: LocationSelector) => void;
} => {
  const theme = useTheme();
  const shouldRenderBottomsheet = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.sm),
  );

  const close = () => {
    closeLocationSelector();
  };

  const open = (locationSelector: LocationSelector) => {
    if (shouldRenderBottomsheet) {
      openLocationSelector(LocationSelector.BOTTOM_SHEET);
    } else {
      openLocationSelector(locationSelector);
    }
  };

  return { close, open };
};
